import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { SuccessResponse } from 'services/requests';
import { MutationKeys } from 'constants/mutationKeys';
import { Messages } from 'constants/messages';
import { QueryKeys } from 'constants/queryKeys';
import { showInfoToast } from 'components/Toast';

export const useRefreshContributions = () => {
  const queryClient = useQueryClient();

  const mutate = async () => {
    const { data } = await api.refreshContributions();

    return data;
  };

  const mutationKey = MutationKeys.refreshContributions;

  return useMutation<SuccessResponse, AxiosError<ApiError>>(mutationKey, mutate, {
    onSuccess: () => {
      queryClient.invalidateQueries(QueryKeys.contributionsList);
      showInfoToast(Messages.contributionsUpdated);
    },
  });
};
